import { Grid, Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    TFormSchema,
    useFetch,
    useForm,
    useGrid,
    useModal,
    usePage,
    useResource,
    useStore,
    useToast,
} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { APIS, BASE, URLS, SF_PRE_VRFN_DOC_INFO } from "@/tra/tancis/ptli/comnmdle/doc/services/PtliDocMgmtService";

/*
 * Pre-Verification Document Registration
 * !== 사전검증 문서 등록 ==!
 */
export const PTLI0412002S = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "COM0025" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });
    const navigate = useNavigate();
    const { pgeStore } = useStore({ pgeUid: pgeUid });
    const modal = useModal();
    const toast = useToast();
    const { t } = useTranslation();

    const form = {
        docInfo: useForm({
            defaultSchema: SF_PRE_VRFN_DOC_INFO,
        }),
    };

    const fetch = {
        createPreVrfnDocInfo: useFetch({
            api: (data: any) => APIS.createPreVrfnDocInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(`${URLS.ptli0412001q}?menuId=${menuId}`);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        onRestBtnClick: () => {
            handler.clearFormState();
            form.docInfo.reset();
        },
        onListBtnClick: () => {
            navigate(`${URLS.ptli0412001q}?menuId=${menuId}`);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.docInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.docInfo.handleSubmit(
                () => {
                    const data = form.docInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createPreVrfnDocInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.docInfo.errors), form.docInfo.isSubmitted);
                },
            )();
        },
        clearFormState: () => {
            form.docInfo.clearErrors();
            form.docInfo.resetSchema();
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docIntfId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docMakeUrlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docNmEn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docNmTz} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.docTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.preValdnYn} />
                            <Group.Control {...form.docInfo.schema.useYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.dclaCoTpCd} />
                        </Group.Row>
                        {/* <Group.Row>
                            <Group.Control {...form.docInfo.schema.dclaCoTpCd2} />
                        </Group.Row> */}
                        <Group.Row>
                            <Group.Control {...form.docInfo.schema.rmrk} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section></Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
